import { captureException } from '@sentry/svelte';
import { consoleSandbox } from '@sentry/utils';

// The SvelteKit default error handler just logs the error to the console
// see: https://github.com/sveltejs/kit/blob/369e7d6851f543a40c947e033bfc4a9506fdc0a8/packages/kit/src/core/sync/write_client_manifest.js#LL127C2-L127C2
function defaultErrorHandler({ error }) {
  consoleSandbox(() => {
    // eslint-disable-next-line no-console
    console.error(error);
  });
}

/**
 * Wrapper for the SvelteKit error handler that sends the error to Sentry.
 *
 * @param handleError The original SvelteKit error handler.
 */
function handleErrorWithSentry(handleError = defaultErrorHandler) {
  return (input) => {
    captureException(input.error, {
      mechanism: {
        type: 'sveltekit',
        handled: false,
      },
    });

    return handleError(input);
  };
}

export { handleErrorWithSentry };
//# sourceMappingURL=handleError.js.map
